/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type PermissionsViewQueryVariables = Types.Exact<{
  email: Types.Scalars['String']['input']
}>

export type PermissionsViewQuery = {
  __typename?: 'Query'
  fleets: Array<{
    __typename?: 'BackofficeUserManagementFleet'
    id: string
    name: string
    operatorTenant: string
  }> | null
  organizations: Array<{
    __typename?: 'BackofficeOrganization'
    id: string
    name: string
  }>
  groups: Array<{
    __typename?: 'BackofficeUserManagementGroup'
    name: string
    displayName: string
  }> | null
}

export const PermissionsViewDocument = gql`
    query permissionsView($email: String!) {
  fleets: backofficeUserFleetsByEmail(email: $email) {
    id
    name
    operatorTenant
  }
  organizations: backofficeOrganizations {
    id
    name
  }
  groups: backofficeUserManagementGroups {
    name
    displayName
  }
}
    `

/**
 * __usePermissionsViewQuery__
 *
 * To run a query within a React component, call `usePermissionsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionsViewQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function usePermissionsViewQuery(
  baseOptions: Apollo.QueryHookOptions<
    PermissionsViewQuery,
    PermissionsViewQueryVariables
  > &
    (
      | { variables: PermissionsViewQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<PermissionsViewQuery, PermissionsViewQueryVariables>(
    PermissionsViewDocument,
    options,
  )
}
export function usePermissionsViewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PermissionsViewQuery,
    PermissionsViewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PermissionsViewQuery,
    PermissionsViewQueryVariables
  >(PermissionsViewDocument, options)
}
// @ts-ignore
export function usePermissionsViewSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PermissionsViewQuery,
    PermissionsViewQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  PermissionsViewQuery,
  PermissionsViewQueryVariables
>
export function usePermissionsViewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PermissionsViewQuery,
        PermissionsViewQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  PermissionsViewQuery | undefined,
  PermissionsViewQueryVariables
>
export function usePermissionsViewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PermissionsViewQuery,
        PermissionsViewQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    PermissionsViewQuery,
    PermissionsViewQueryVariables
  >(PermissionsViewDocument, options)
}
export type PermissionsViewQueryHookResult = ReturnType<
  typeof usePermissionsViewQuery
>
export type PermissionsViewLazyQueryHookResult = ReturnType<
  typeof usePermissionsViewLazyQuery
>
export type PermissionsViewSuspenseQueryHookResult = ReturnType<
  typeof usePermissionsViewSuspenseQuery
>
export type PermissionsViewQueryResult = Apollo.QueryResult<
  PermissionsViewQuery,
  PermissionsViewQueryVariables
>
